module.exports = __webpack_public_path__ + "assets/img/f84d7480495b6af55100662693a14ccf.png";